import { forwardRef } from "react";
import ReCAPTCHA, { ReCAPTCHAProps } from "react-google-recaptcha";

// `sitekey` is optional: per-domain callers (e.g. guest booking) pass the config-driven key so the
// widget pairs with the backend's verifying secret; everyone else falls back to the build-time env key.
export type RecaptchaProps = Omit<ReCAPTCHAProps, "sitekey"> & { sitekey?: string };

// forwardRef exposes the underlying ReCAPTCHA instance (`.reset()`), so callers can drop a consumed/
// expired token and force a fresh solve after a failed submit — reCAPTCHA v2 tokens are single-use and
// expire in ~2 min, so a resent token fails server verification ("verification failed").
export const Recaptcha = forwardRef<ReCAPTCHA, RecaptchaProps>(({ onChange, className, sitekey, ...props }, ref) => {
  const resolvedSitekey =
    sitekey || import.meta.env.VITE_RIDEMINDER_GOOGLE_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

  return <ReCAPTCHA ref={ref} sitekey={resolvedSitekey} onChange={onChange} className={className} {...props} />;
});

Recaptcha.displayName = "Recaptcha";
